import { TextField } from "@mui/material";
import { useState } from "react";

interface CamposDeEntradaProps {
    texto?: string,
    tipo?: string,
    valor?: string,
    obrigatorio?: boolean,
    onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
}

export function CamposDeEntrada({ texto, tipo, valor, onChange, obrigatorio }: CamposDeEntradaProps) {
    const [erro, setErro] = useState(false);

    const handleBlur = () => {
        if (obrigatorio && (!valor || valor.trim() === '')) {
            setErro(true);
        } else {
            setErro(false);
        }
    };

    const FormHelperTextProps = {
        sx: {
            margin: 0.5,
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
        },
    }

    return (
        <TextField
            FormHelperTextProps={FormHelperTextProps}
            label={texto}
            type={tipo}
            value={valor}
            sx={{
                '& .MuiInputLabel-root.Mui-focused': {
                    color: '#E9775F',
                },
                '& .MuiInputLabel-root.Mui-hover': {
                    color: '#E9775F',
                },
                '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                        borderColor: '#E9775F',
                        borderWidth: '2px',
                    },
                },
            }}
            onChange={(e) => {
                if (onChange) onChange(e);
                if (erro && e.target.value.trim() !== '') {
                    setErro(false);
                }
            }}
            onBlur={handleBlur}
            error={erro}
            helperText={erro ? 'Campo obrigatório' : ''}
        >

        </TextField>
    )
}